import { useState, useEffect } from 'react';
import { fetchCampaignSpots } from '../services/firestoreService';

/**
 * スタンプラリーデータ取得カスタムフック
 * 
 * - ページ読み込み時にFirestoreからデータ取得（1回のみ）
 * - エラー時は前回データを維持（spotsをリセットしない）
 * - タイムアウト: 10秒（firestoreService側で制御）
 * 
 * @param {string} campaignId - キャンペーンID（例: "ueno"）
 * @returns {{ spots: Array, updatedAt: Date|null, loading: boolean, error: Error|null }}
 */
const useStampRallyData = (campaignId) => {
  const [spots, setSpots] = useState([]);
  const [updatedAt, setUpdatedAt] = useState(null);
  const [gasLastUpdated, setGasLastUpdated] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let isCancelled = false;

    const fetchData = async () => {
      setLoading(true);
      setError(null);

      try {
        const data = await fetchCampaignSpots(campaignId);

        if (!isCancelled) {
          setSpots(data.spots);
          setUpdatedAt(data.updatedAt);
          setGasLastUpdated(data.gasLastUpdated);
        }
      } catch (err) {
        if (!isCancelled) {
          console.error('データ取得エラー:', err);
          setError(err);
          // ※ spots はリセットしない（前回データを維持）
        }
      } finally {
        if (!isCancelled) {
          setLoading(false);
        }
      }
    };

    fetchData();

    return () => {
      isCancelled = true;
    };
  }, [campaignId]);

  return { spots, updatedAt, gasLastUpdated, loading, error };
};

export default useStampRallyData;
